import { FC, SVGProps } from 'react';

const FloatingArrow: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    {...props}
    viewBox="0 0 12 4"
    preserveAspectRatio="none"
    aria-hidden="true">
    <path d="M0 0H12L7.2 3.4Q6 4.3 4.8 3.4Z" />
  </svg>
);

export default FloatingArrow;
